export default "__VITE_ASSET__Jc0sjS9f__"